export const getQueryParam = (searchParams, key) => {
  const value = searchParams.get(key);
  return value === 'true' || value == 1 || value == '1'; // Mengembalikan boolean true/false asli
};